import { render, staticRenderFns } from "./serviceSubscript.vue?vue&type=template&id=04661b31&scoped=true"
import script from "./serviceSubscript.vue?vue&type=script&lang=js"
export * from "./serviceSubscript.vue?vue&type=script&lang=js"
import style0 from "./serviceSubscript.vue?vue&type=style&index=0&id=04661b31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04661b31",
  null
  
)

export default component.exports